/**
 * @file api-checkout-settings.ts
 * @description API-клиент настроек публичного checkout (phase19, [OPEN]-4).
 *
 * Endpoints `/admin/shop/checkout-settings`. RBAC — SHOP_MANAGE_SETTINGS в API.
 */

import { apiFetch } from "./api-client";

export interface CheckoutOwnerRef {
  id: string;
  displayName: string | null;
  email: string;
}

export interface CheckoutSettingsDto {
  defaultOrderOwner: CheckoutOwnerRef | null;
  candidates: CheckoutOwnerRef[];
}

export function getCheckoutSettings(): Promise<CheckoutSettingsDto> {
  return apiFetch<CheckoutSettingsDto>("/admin/shop/checkout-settings");
}

export function updateCheckoutSettings(payload: {
  defaultOrderOwnerUserId: string | null;
}): Promise<CheckoutSettingsDto> {
  return apiFetch<CheckoutSettingsDto>("/admin/shop/checkout-settings", {
    method: "PATCH",
    json: payload,
  });
}
